import axios from "axios";
import { environment } from "../config";
import { ApiBrokerResponseStructure } from "../interfaces/DataDefaultStructureResponse";
import { iObjetivoAprendizaje } from "../interfaces/ObjetivosAprendizaje/iObjetivosAprendizaje";
import { baseUrlNivelesMateriasObjetivos } from "./baseApiUrl";

const { REACT_APP_API_CONTROL_TRANSACCIONAL } = environment;
const baseApiBroker = REACT_APP_API_CONTROL_TRANSACCIONAL;

export const postAuditActionEvent = async (
  userId: string,
  id_organizacion: string,
  event: string,
  aplication: string,
  description: string
): Promise<ApiBrokerResponseStructure<any[]>> => {
  const url = `${baseApiBroker}/auditoria`;
  const headers = { "Content-Type": "application/json" };

  const body = {
    id_usuario: userId,
    accion: event,
    aplicativo: aplication,
    descripcion: description,
    dato_anterior: null,
    dato_nuevo: {
      nombre: "",
      estado: "",
    },
  };

  try {
    const response = await axios.post(url, {
      headers, // Pasa los headers aquí
      data: body, // Pasa el cuerpo de la solicitud como 'data'
    });
    const { data, status } = response;
    return Object.assign({ data, status });
  } catch (error: any) {
    console.error(
      "postAuditActionEvent: Se produjo un error al realizar la solicitud a la API:" +
        error
    );
    throw new Error("No es posible auditar el evento" + error);
  }
};

export const getObjectives = async (
  pais: string,
  asignatura: string,
  nivel: string
): Promise<ApiBrokerResponseStructure<iObjetivoAprendizaje[]>> => {
  try {
    const params = new URLSearchParams();
    params.append("pais", pais);
    params.append("asignatura", asignatura);
    params.append("nivel", nivel);

    const queryString = params.toString();
    const url = `${baseUrlNivelesMateriasObjetivos}/objetivos?${queryString}`;

    const response = await axios.get(url);
    const { data, status } = response;
    return Object.assign({ data, status });
  } catch (error) {
    console.error(
      "getObjectives: Se produjo un error al realizar la solicitud a la API:" +
        error
    );
    throw new Error("No es posible obtener los objetivos" + error);
  }
};